<template>
  <div>
    <div class="actions-cell" v-if="!isTrashDiffusion">
      <a v-has-permission="'lives_flux_live_no_api'" has-permission="lives_flux_live_no_api" class="actions " :title="$t('button.flow')" target="_blank"
        v-if="hasUrlFlow(row.item.url_player)" @click="setUrlFluxLive(row.item.url_player)">
        <b-button variant="diffusion" class="diffusion-btn" >
          <i class="actionIcons btn-icons icon-flux"></i>
          {{ $t('button.flow') }}
        </b-button>
      </a>
                      <a class="actions " title="start" target="_blank" @click="startLive(row.item)"
                      v-if=" row.item.status !== 1  && !getArchivedLive  && row.item.isPearl && !!!row.item.active"
                      >
        <b-button variant="diffusion" class="diffusion-btn">
          <font-awesome-icon
  class="actionIcons btn-icons play-icon"
  :icon="{ prefix: 'fas', iconName: 'play' }"
/>

          Start
        </b-button>


      </a>
      <a class="actions " title="stop" target="_blank" @click="stopLive(row.item)"
        v-if="(row.item.isPearl) && row.item.active && row.item.status !== 1">
        <b-button variant="diffusion" class="diffusion-btn">
          <font-awesome-icon
  class="actionIcons btn-icons stop-icon"
  :icon="{ prefix: 'fas', iconName: 'stop' }"
/>

          Stop
        </b-button>


      </a>
      <a class="actions " :title="$t('button.view')" target="_blank" @click="actionDetail(row.item)"
        v-if="row.item.active">
        <b-button variant="diffusion" class="diffusion-btn">
          <font-awesome-icon class="actionIcons btn-icons" :icon="{ prefix: 'fas', iconName: 'eye' }" />
          {{ $t('button.visualize') }}
        </b-button>


      </a>
      <a v-has-permission="getDiffusionPermission(row.item)"
      v-bind:has-permission="getDiffusionPermission(row.item)" 
      v-if="(row.item.status === 1 && !getArchivedLive) || shouldShowDiffusionButton"
      class="actions" 
      :title="$t('button.diffusion')"
       target="_blank"
       @click="handleDiffusionClick(row.item)"

       >
      <b-button
       v-if="row.item.status === 1 && !getArchivedLive"
       variant="reduffison" 
       class="diffusion-btn"
   >
       <font-awesome-icon class="actionIcons btn-icons" 
       :icon="{ prefix: 'fas', iconName: 'video' }" />
       {{ $t('button.restart') }}
       </b-button>
      <b-button 
       v-else-if="shouldShowDiffusionButton"
       variant="diffusion" 
       class="diffusion-btn"
     >
       <font-awesome-icon class="actionIcons btn-icons" 
       :icon="{ prefix: 'fas', iconName: 'video' }" />
      {{ $t('button.diffusion') }}
  </b-button>
</a>
    

      <a v-has-permission="'lives_restart_live_no_api'" has-permission="lives_restart_live_no_api" class="actions " :title="$t('button.restart')"
        v-if="getArchivedLive" @click="restartLive(row.item.id)">
        <b-button variant="diffusion" class="diffusion-btn" >
          <font-awesome-icon class="actionIcons btn-icons" :icon="{ prefix: 'fas', iconName: 'video' }" />
          {{ $t('button.restart') }}
        </b-button>


      </a>
      <a class="actions " :title="$t('button.edit')" target="_blank" @click="GoToEditLive(row.item.id)"
        v-has-permission="'lives_post_edit'" has-permission="lives_post_edit" v-if="!getArchivedLive && row.item.status !== 1"><font-awesome-icon
          class="actionIcons " :icon="{ prefix: 'fas', iconName: 'pencil-alt' }" /></a>
      <a v-has-permission="'lives_live_detail_no_api'" has-permission="lives_live_detail_no_api" class="actions " :title="$t('button.view')" target="_blank"
        @click="openViewModalById(row.item.id)"><font-awesome-icon class="actionIcons "
          :icon="{ prefix: 'fas', iconName: 'eye' }" /></a>
      <a v-has-permission="'lives_delete_live'" has-permission="lives_delete_live" class="actions " :title="$t('button.delete')"
        target="_blank"><font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'trash' }"
          @click="openModalDeleteLive(row.item, 'archiving')" /></a>

      <a v-has-permission="'lives_stats_no_api'" has-permission="lives_stats_no_api" class="actions " :title="$t('button.statistics')"
        target="_blank"><font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'chart-bar' }"
          @click="sendPostMessageLive(row.item, 'goToStaticsLive')" /></a>

      <a v-has-permission="'lives_add_screen_share'" has-permission="lives_add_screen_share" class="actions " :title="$t('button.share')" target="_blank"
        v-if="row.item.screenShare && !getArchivedLive">
        <font-awesome-icon class="actionIcons " :icon="{ prefix: 'fab', iconName: 'chromecast' }"
          @click="openScreenShareModal(row.item.id)" />
      </a>
      <a v-has-permission="'lives_add_screen_share'" has-permission="lives_add_screen_share" class="actions " :title="$t('button.download')" target="_blank"
        v-if="row.item.screenShare">
        <font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'file-download' }"
          @click="downloadScreenFile(row.item)" />
      </a>
      <a v-has-permission="'lives_export_link_no_api'" has-permission="lives_export_link_no_api" class="actions " :title="$t('button.link_export')" target="_blank"
        v-if="row.item.status !== 1 || getShowExportBtnArchived"
        @click="openExportLinkLive(row.item.id)"><font-awesome-icon class="actionIcons "
          :icon="{ prefix: 'fas', iconName: 'link' }" /></a>
      <a v-if="!row.item.webinar" v-has-permission="'lives_live_info_no_api'" has-permission="lives_live_info_no_api" class="actions " :title="$t('button.infos')"
        target="_blank"><font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'info-circle' }"
          @click="openInfosLive(row.item.id)" /></a>

      <!-- <a  v-has-permission="'lives_comments_no_api'" class="actions " :title="$t('button.comments')"
        target="_blank"><font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'comment-alt' }"
          @click="sendPostMessageLive(row.item, 'goToCommentLive')"/></a> -->

      <!-- <a v-if="row.item.isPearl" v-has-permission="'lives_encoder_no_api', getDiffusionPermission(row.item)"
        class="actions " :title="$t('button.encoding')" target="_blank"
        @click="sendPostMessageLive(row.item, 'goToEncodingLive')">
        <svg class="actionIcons" version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512"
          viewBox="0 0 512 512">
          <path fill="#747474"
            d="M442.589 92.981c-67.261-99.492-182.79-112.743-267.374-69.911-49.255 24.941-81.102 66.602-104.892 115.060-25.895 52.747-39.331 109.067-46.262 167.075-2.838 23.756-4.905 47.623-1.959 71.769 0.399-1.089 0.997-2.149 1.172-3.274 6.556-42.334 22.144-81.297 45.419-117.002 62.863-96.431 150.603-144.542 266.978-134.338 34.425 3.019 65.705 15.782 90.493 40.84 32.455 32.809 40.697 73.757 35.834 117.776-3.057 27.671-16.356 37.718-45.187 37.974-75.676 0.673-151.354 1.28-227.031 1.884-16.146 0.129-22.85 5.672-25.034 21.433-2.631 18.972-2.899 37.925-0.294 57.004 9.114 66.76 69.15 116.338 136.385 112.522 50.115-2.844 90.197-25.31 122.463-62.651 31.868-36.879 49.139-80.767 59.705-127.71 18.409-81.8 6.875-158.5-40.416-228.454z">
          </path>
          <path fill="#747474"
            d="M263.716 273.855c12.122-0.692 22.75-1.026 33.317-2.010 5.875-0.546 11.642-2.216 17.471-3.303 14.675-2.736 22.755-12.098 26.050-26.103 1.94-8.248 2.786-16.619 2.007-25.125-2.983-32.572-25.12-51.807-55.978-47.641-43.309 5.845-75.094 29.175-96.606 66.603-11.086 19.286-4.163 32.083 18.157 34.148 18.964 1.759 38.028 2.391 55.581 3.43z">
          </path>
        </svg>
      </a> -->
      <!-- <a
        class="actions "
        :title="$t('button.show_live')"
        target="_blank"
        @click="openPreviewArchivedVideo(row.item.id)"
        v-if="getArchivedLive"
        v-has-permission="'lives_dtable_preview_video'"
      >
        <font-awesome-icon class="actionIcons " icon="play-circle"></font-awesome-icon>
      </a>-->

           <a v-has-permission="'lives_live_inscrits_list_no_api'" has-permission="lives_live_inscrits_list_no_api" target="_blank" class="actions" :title="$t('button.export')" @click="GotToExport(row.item.id)">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M1.615 16C1.155 16 0.771 15.846 0.463 15.538C0.154333 15.2293 0 14.845 0 14.385V1.615C0 1.155 0.154333 0.771 0.463 0.463C0.771 0.154333 1.155 0 1.615 0H14.385C14.845 0 15.229 0.154333 15.537 0.463C15.8457 0.771 16 1.155 16 1.615V14.385C16 14.845 15.846 15.229 15.538 15.537C15.2293 15.8457 14.845 16 14.385 16H1.615ZM1 4.998H15V1.615C15 1.46167 14.936 1.32067 14.808 1.192C14.6793 1.064 14.5383 1 14.385 1H1.615C1.46167 1 1.32067 1.064 1.192 1.192C1.064 1.32067 1 1.46167 1 1.615V4.998ZM1 10.002H15V5.998H1V10.002ZM1.615 15H14.385C14.5383 15 14.6793 14.936 14.808 14.808C14.936 14.6793 15 14.5383 15 14.385V11.002H1V14.385C1 14.5383 1.064 14.6793 1.192 14.808C1.32067 14.936 1.46167 15 1.615 15ZM2.77 3.804V2.188H4.386V3.804H2.77ZM2.77 8.808V7.192H4.386V8.808H2.77ZM2.77 13.812V12.196H4.386V13.812H2.77Z" fill="#757575"/>
  </svg>
</a>


      <a v-has-permission="'lives_upload_no_api'" has-permission="lives_upload_no_api" class="actions upload-btn" :title="$t('button.upload')" target="_blank"
        @click="uploadLive(row.item.id)" v-if="getArchivedLive">
        <i class="icon-upload"></i>
      </a>

      <!-- export questions button -->
      <a v-has-permission="'comment_post_export'" has-permission="comment_post_export_action" class="actions" :title="$t('button.export_questions')" target="_blank" v-if="getArchivedLive" @click="exportQuestions(row.item.id)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path d="M14.625 9.32812C14.625 11.599 13.1111 15.3837 7.8125 15.3837C2.51389 15.3837 1 11.599 1 9.32812" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.81543 1.03906V11.5983" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.27075 5.54167L7.81242 1L12.3541 5.54167" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>

    </div>
    <div class="actions-cell" v-if="isTrashDiffusion">
      <a v-has-permission="'lives_trash_delete_live'" has-permission="lives_trash_delete_live" class="actions " :title="$t('button.delete')"
        target="_blank"><font-awesome-icon class="actionIcons " :icon="{ prefix: 'fas', iconName: 'trash' }"
          @click="openModalDeleteLive(row.item, 'deleting')" /></a>
      <a v-has-permission="'lives_restore_no_api'" has-permission="lives_restore_no_api" class="actions restore-btn" :title="$t('button.restore')"
        target="_blank" @click="openModalDeleteLive(row.item, 'restoring')">
        <i class="icon-backup-restore"></i>
      </a>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Toasted from 'vue-toasted';
import UploadMixin from '../../mixins/UploadMixin.js';
import UtilsMixin from '../../mixins/UtilsMixin.js';
import NProgress from 'nprogress';
import '../../assets/scss/nprogress.scss';
import VueSelect from 'vue-select';
import 'vue-select/src/scss/vue-select.scss';
import { acces_send } from '../../service/access_service';
import i18n from '../../i18n/index.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import VueMoment from 'vue-moment';
import * as moment from 'moment';
import HasPermission from '../../directives/HasPermission.js';
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';
import 'moment/locale/pt-br';
export default {
  name: 'ActionButtons',
  components: {
    Toasted,
    VueSelect,
    VueMoment,
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: {
    row: {
      type: Object,
      default: {},
    },
  },
  directives: {
    HasPermission,
  },
  data() {
    return {
      fields: [
        { key: 'check', label: '', class: 'd-none d-md-table-cell' },
        {
          key: 'id',
          id: '0',
          label: i18n.t('table.list.id'),
          sortable: true,
          class: 'd-none d-lg-table-cell',
        },
        {
          key: 'thumbnail',
          id: '1',
          label: i18n.t('table.list.preview'),
          class: 'd-none d-lg-table-cell',
        },
        {
          key: 'title',
          id: '2',
          label: i18n.t('table.list.title'),
          sortable: true,
          class: 'd-none d-md-table-cell',
        },
        {
          key: 'description',
          id: '3',
          label: i18n.t('table.list.description'),
          sortable: true,
          class: 'd-none d-md-table-cell',
        },
        {
          key: 'active',
          id: '4',
          label: i18n.t('table.list.active'),
          class: 'd-none d-md-table-cell',
        },
        {
          key: 'dateStart',
          id: '5',
          label: i18n.t('table.list.date'),
          sortable: true,
          class: 'd-none d-lg-table-cell',
        },
        {
          key: 'actions',
          id: '6',
          label: i18n.t('table.list.actions'),
          class: 'd-none d-md-table-cell',
        },
        { key: 'mobile-details', id: '7', class: 'd-table-cell d-md-none' },

        { key: 'show_details', id: '8', class: 'd-table-cell d-md-none w-50px' },
      ],
      statusLive: 'start',

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 20, 30, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      checkedAll: true,
      mdTime: { date: new Date(), time: '', endtime: '' },
      active: false,
      indeterminate: false,
      periods: ['period', 'week', 'month', 'trimester', 'semester', 'year'],
      tableValues: [],
      totalRows: 1,
      allSelected: false,
      type: 'endless',
      obj: {},
      showTrash: false,
      checkedItems: false,
      selected: [],
      selectedAll: [],
      checked: false,
      isActive: true,
      selectedList: [],
      openModalDelete: false,
      selectedContributor: '',
      substitle: '',
      liveId: '',
      live: {},
      showAllSlides: false,
      diffusionSelected: false,
      numColumn: 0,
      selectedRows: [],
      clickedIcon: false,
      selectedUser: false,
      invitations: [],
      headerBgVariant: 'primary',
      headerTextVariant: 'white',
      screenType: 'pip',
      screenTypeOptions: [
        { value: 'pip', text: 'Picture in Picture PIP' },
        { value: 'sbs', text: 'Side by Side' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      allLives: 'lives/getAllLives',
      getContributors: 'lives/getContributors',
      getLive: 'lives/getLive',
      getTotalLive: 'lives/getTotalLive',
      getInfoDetailLive: 'lives/getInfoDetailLive',
      getLinkExportLives: 'lives/getLinkExportLives',
      getSubscriptionUser: 'lives/getSubscriptionUser',
      getArchivedLive: 'lives/getArchivedLive',
      downloadFile: 'lives/getUrlDownloadFile',
      getDiffusion: 'common/getDiffusion',
      getShowExportBtnArchived: 'common/getShowExportBtnArchived',
      getDownloadLive: 'common/getDownloadLive',
    }),
    isTrashDiffusion() {
      return this.getDiffusion === 'trash'
    },
    iframe() {
      return (
        '<iframe style="width:100%;height:100%;min-height:560px" src="' +
        this.getLinkExportLives['embed'] +
        '" allowfullscreen mozallowfullscreen webkitallowfullscreen frameborder="0" allow="autoplay;"></iframe>'
      );
    },
    shouldShowDiffusionButton() {
        const { getDiffusion, row } = this;
        const isVisibleButton =(getDiffusion === 'endless' || getDiffusion ==='upcoming' || getDiffusion ==='all') && !row.item.isPearl && row.item.webinar;
    return isVisibleButton;
    },
  },
  methods: {
    ...mapActions('lives', ['apiShareLink']),

    ...mapActions({
      paginate: 'lives/paginate',
      getAllContributors: 'lives/fetchContributors',
      deleteMultiLive: 'lives/deleteMultiLive',
      deleteLiveById: 'lives/deleteLiveById',
      exportQuestionsByLiveId: 'lives/exportQuestionsByLiveId',
      setDisableLiveById: 'lives/setDisableLiveById',
      setStopLiveById: 'lives/setStopLiveById',
      setEnableLiveById: 'lives/setEnableLiveById',
      getLiveById: 'lives/getLiveById',
      getInfosDetail: 'lives/getInfosDetail',
      getLinkExport: 'lives/getLinkExport',
      sendInvitationsMails: 'lives/sendInvitationsMails',
      setScreenShare: 'lives/setScreenShare',
      getUrlDownloadFile: 'lives/getUrlDownloadFile',
      getSubscriptionUserList: 'lives/getSubscriptionUserList',
      getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
      getUrlLinkArchivedVideo: 'lives/getUrlLinkArchivedVideo',
      setLives: 'lives/setLives',
      removeLiveById: 'lives/removeLiveById',
      restartDiffusionLive: 'lives/restartDiffusionLive',
      downloadLive: 'lives/downloadLive',
      setShowModal: 'common/setShowModal',
    }),
    handleDiffusionClick(item) {
  if (item.status === 1 && !this.getArchivedLive) {
    this.restartLive(item.id);
  } else if (this.shouldShowDiffusionButton) {
    this.sendPostMessageDiffusionLive(item, "goToDiffusionLive");
  }
},
    hasUrlFlow(urlFlow) {
      return (this.getDiffusion === 'endless' || this.getDiffusion ==='upcoming') && urlFlow && urlFlow !== ''
    },
    async openModalDeleteLive(live, action) {
      acces_send('lives_delete_live_action');
      NProgress.start();
      this.liveId = live.id;
      await this.$root.$emit('setDeleteLiveActivity', { action: action, live: live, multi: false });
      NProgress.done();
    },
    async setUrlFluxLive(flow) {
      acces_send('lives_flux_live_no_api_action')
      NProgress.start();
      await this.$root.$emit('setUrlFlow', flow);
      NProgress.done();
    },
    async uploadLive(id) {
      acces_send('lives_upload_no_api_action')
      NProgress.start();
      var ua = navigator.userAgent;
      let type = 'success_download'
      try {
        const url = Routing.generate('api_download_live', { id: id})  + '?isLive=true'  ;
        await HTTP(window.ApiToken)
          .get(url)
          .then(response => {
            let downloadLive = response.data.data;
            if (downloadLive) {
              if (downloadLive.exist) {
                if (ua.indexOf('Firefox') !== -1) {
                  window.open(downloadLive.file, '_blank');
                } else {
                  window.location.href = downloadLive.file;
                }
                type = ''
              } else {
                type = 'not-exist'
              }
            }
          }).catch(e => {
            type = 'error'
          })

      } catch (e) {
        type = 'error'
      }
      if (type) {
        this.callPopupConfirm(type, i18n.t("toast." + type))
      }
      NProgress.done();

    },
    async exportQuestions(id) {
        try {
          const response = await this.exportQuestionsByLiveId(id);
          console.log("response: ", response)
          const strMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
          new Blob([response.data], { type: strMimeType })
          );
          downloadLink.download = "les questions du live " + id + ".xlsx";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.showToast('success', i18n.t('toast.export_questions_success'), 'icon-success');
        } catch(e) {
          console.log("error while exporting questions", e);
          if (e.response.status === 404) {
            this.showToast('error', i18n.t('toast.no_questions_to_export'), 'icon-warning');
          } else {
            this.showToast('error', i18n.t('toast.export_questions_error'), 'icon-warning');
          }
        }
    },
    callPopupConfirm(type, message) {
      const h = this.$createElement;
      const messageVNode = h('div', { class: ['msg-box-download '] }, [
        h('i', { class: ['icon-' + (type.indexOf('success') > -1 ? 'success' : 'warning') + (' btn-download--' + (type.indexOf('success') > -1 ? 'success' : 'error'))] }),
        h('p', { class: ['text-center message-box'] }, [
          message,
        ]),
      ])
      this.$bvModal.msgBoxOk(messageVNode, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: (type.indexOf('success') > -1 ? 'success' : 'danger'),
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0 footer-box-download',
        centered: true,
      })
        .then(value => {
        })
        .catch(err => {
          // An error occurred
        })
    },
    getDiffusionPermission(item) {
      if (item.isPearl) {
        return "lives_pearl_diffuser_no_api"
      } else {
        return "lives_diffuser_no_api"
      }
    },
    async startLive(live) {
      NProgress.start();
      this.liveId = live.id;
      await this.$root.$emit('ChangeActivity', { event: true, live: live });
      NProgress.done();
    },
    async stopLive(live) {
      NProgress.start();
      this.liveId = live.id;
      await this.$root.$emit('ChangeActivity', { event: false, live: live });
      NProgress.done();
    },
    GotToExport(idLive){
      parent.postMessage(
        {
          info: 'goToListLive',
          id: idLive,
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      let exportLive = 'ExportLive';
      if (window.process.env.HAS_SKIN === 'true') {
        exportLive = 'ExportLiveV2';
      }
      this.$router.push({ name: exportLive, params: { id: idLive }, query: cryptext });
      // this.eventPostMessage();
    },
    GoToEditLive(idLive) {
      acces_send('lives_post_edit_action')
      parent.postMessage(
        {
          info: 'goToEditLive',
          id: idLive,
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      let editLive = 'EditLive';
      if (window.process.env.HAS_SKIN === 'true') {
        editLive = 'EditLiveV2';
      }
      this.$router.push({ name: editLive, params: { id: idLive }, query: cryptext });
      // this.eventPostMessage();
    },


    async openViewModalById(id) {
      acces_send('lives_live_detail_no_api_action');
      NProgress.start();
      this.liveId = id;
      await this.getLiveById(id);
      this.$root.$emit('bv::show::modal', 'modal-view-row');
      await await this.$root.$emit('isOpenModal', {
        id: 'modal-view-row',
      });
      //this.$refs['modal-view-row'].show();
      NProgress.done();
    },
    async openExportLinkLive(id) {
      acces_send('lives_export_link_no_api_action');
      NProgress.start();
      await this.getLinkExport(id);
      await this.$root.$emit('bv::show::modal', 'modal-link-export-row');
      await this.$root.$emit('isOpenModal', {
        id: 'modal-link-export-row',
      });
      //this.$refs['modal-link-export-row'].show();
      NProgress.done();
    },
    async goToExportLinkLive(id) {
      let response = await this.getLinkExport(id);
      if (response.code === 200) {
        let exportLink = response.permalien;
        if (Array.isArray(response.permalien)) {
          exportLink = response.permalien[0];
        }
        window.open(exportLink, '_blank');
      }
    },
    sendPostMessageLive(value, info) {

      switch (info) {
        case "goToStaticsLive":
          acces_send('lives_stats_no_api_action');
          break;
        case "goToCommentLive":
          acces_send('lives_comments_no_api_action');
          break;
        case "goToEncodingLive":
          acces_send('lives_encoder_no_api_action');
          break
      }

      NProgress.start();
      parent.postMessage(
        {
          info: info,
          id: value.id,
        },
        '*',
      );
      NProgress.done();
    },
    actionDetail(data) {
      if (data.status == 1) {
        this.openPreviewArchivedVideo(data.id)
      } else {
        this.goToExportLinkLive(data.id)
      }
    },
    restartLive(liveId) {
      acces_send('lives_restart_live_no_api_action')
      this.restartDiffusionLive(liveId)
    },
    sendPostMessageDiffusionLive(value, info) {
      acces_send('lives_diffuser_no_api_action')
      if (window.process.env.HAS_DIFFUSION_ENCODER) {
        NProgress.start();
        parent.postMessage(
          {
            info: info,
            live: value,
          },
          '*',
        );
        NProgress.done();
      } else {
        let objectPusher = {
          data: JSON.stringify({ date: new Date().getTime() }),
          prefixChannelName: 'broadcast',
          event: 'show-in-stream'
        }
        this.setEnableLiveById({ id: value.id, active: true });


      }

    },
    async openInfosLive(id) {
      acces_send('lives_live_info_no_api_action');
      NProgress.start();

      this.liveId = id;
      await this.getInfosDetail(id);
      await this.$root.$emit('isOpenModal', {
        id: 'modal-infos-live-row',
      });
      NProgress.done();
    },
    async openInvitationModalLive(live) {
      acces_send('lives_send_mail_no_api_action')
      NProgress.start();
      this.liveId = live.id;
      await this.getSubscriptionUserList();
      this.$root.$emit('setLiveId', live.id);
      this.$root.$emit('setLiveObject', live);
      await this.$root.$emit('bv::show::modal', 'modal-send-invitations-row');
      await this.$root.$emit('isOpenModal', {
        id: 'modal-send-invitations-row',
      });
      // this.$refs['modal-send-invitations-row'].show();
      NProgress.done();
    },

    async redirectToFormSendGrid(live) {
      acces_send('lives_send_mail_send_grid_no_api_action')
      NProgress.start();
      this.liveId = live.id;
      this.$router.push({ name: "mailSendGrid", params: { id: this.liveId } });
      NProgress.done();
    },
    async openGroupMailsModalLive(id) {
      try {
        acces_send('lives_send_group_mails_no_api_action')
        NProgress.start();
        this.liveId = id;
        await this.getSubscriptionGroupUsersList();
        this.$root.$emit('setLiveId', id);
        await this.$root.$emit('bv::show::modal', 'modal-send-group-mails-row');
        await this.$root.$emit('isOpenModal', {
          id: 'modal-send-group-mails-row',
        });
        NProgress.done();
      } catch (e) {
        console.log("ERROR:", e);
        NProgress.done();
      }

    },
    async openShareLiveModalLive(id) {
      acces_send('lives_share_email_no_api_action')
      NProgress.start();
      this.liveId = id;
      try {
        await this.getLiveById(id);
        await this.getSubscriptionGroupUsersList();
        await this.getSubscriptionUserList();
        // input id output  link
        // set store  output  {link id }
        this.apiShareLink(id);
        this.setShowModal(true);



        this.$root.$emit('setLiveId', id);
        await this.$root.$emit('bv::show::modal', 'modal-share-link');
        await this.$root.$emit('isOpenModal', {
          id: 'modal-share-link',
        });
        NProgress.done();
      } catch (e) {
        console.log("ERROR: ", e);
        NProgress.done();
      }

    },
    async openScreenShareModal(id) {
      acces_send('lives_add_screen_share_action');
      NProgress.start();
      //this.liveId = id;
      this.$root.$emit('setLiveId', id);
      await this.$root.$emit('bv::show::modal', 'modal-screen-share-row');
      await this.$root.$emit('isOpenModal', {
        id: 'modal-screen-share-row',
      });
      NProgress.done();
      //   this.$refs['modal-screen-share-row'].show();
    },
    async downloadScreenFile(item) {
      acces_send('lives_add_screen_share_action');
      NProgress.start();
      let message;
      try {
        await this.getUrlDownloadFile(item.id);
        await this.downloadURI(this.downloadFile.url_jnlp_file, item.title);
        message = i18n.t('toast.success_download');
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }
      NProgress.done();
    },
    async openPreviewArchivedVideo(id) {
      NProgress.start();
      try {
        await this.getUrlLinkArchivedVideo(id);
      } catch (error) {
        if (error.code === 404 || error.code === 500) {
          console.log('ereeeur not found');
        } else {
          console.log('ereeeur not transcripted');
        }
      }
      await this.$root.$emit('bv::show::modal', 'modal-preview-archived-video');
      await this.$root.$emit('isOpenModal', {
        id: 'modal-preview-archived-video',
      });
      NProgress.done();
    },
    
  },
  mounted() {
    this.$root.$on('setFormLang', lang => {
      // this.$i18n.locale = lang;

      i18n.locale = lang;
    });
    moment.locale('fr');
    //this.eventPostMessage();
  },
};
</script>

<style scoped lang="scss">
.actions-cell {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  vertical-align: middle;
  flex-wrap: wrap;
}

.play-icon {
  color: #1fad5a!important; /* green */
}

.stop-icon {
  color: #d50000!important; /* red */
}
.actionIcons {
  width: 1em;
  height: 1em;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  fill: rgba(0, 0, 0, 0.54);

  svg {
    fill: rgba(0, 0, 0, 0.54);
    color: rgba(0, 0, 0, 0.54);
  }

  &.btn-icons {
    width: 2em;

    &:not(.icon-flux) {
      height: 1.2em;
    }
  }
}

.play-icon,
.play-icon svg,
.play-icon svg path {
  color: #1fad5a !important;
  fill: #1fad5a !important;
}

.stop-icon,
.stop-icon svg,
.stop-icon svg path {
  color: #d50000 !important;
  fill: #d50000 !important;
}

.upload-btn,
.restore-btn {

  .icon-upload,
  .icon-backup-restore {
    cursor: pointer;

    &:before {
      color: rgba(0, 0, 0, 0.54);
      font-weight: bold;
    }
  }
}

.actions {
  padding: 0.4em 0.8em;
  display: flex;
  background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 2px 0 rgba(0, 0, 0, .015);
    cursor: pointer;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

  &>*{
    cursor: pointer;
  }
}

.view-btn,
.diffusion-btn {
  border-radius: 4px;
  // border: solid 1px #c5c5c5;
  font-family: Arial;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #727272;
  display: flex;
  align-items: center;
  // background: #f1f1f1;
  padding: 0;

  &:active,
  &.active,
  &:focus {
    color: #727272 !important;
  }
}

.danger-btn {
  border-radius: 4px;
  font-family: Arial;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  display: flex;
  align-items: center;

}
</style>



// WEBPACK FOOTER //
// src/components/components/ActionButtons.vue